// @flow
import { Record } from 'immutable';
import EmptyList from './EmptyList';
import { List } from 'immutable';
import ClientSpecificQuestion from './ClientSpecificQuestion';

type ReviewRecordShape = {
  assigned_to: null,
  assigned_by: null,
  editable: boolean,
  ugc_id: ?string,
  subject_id: ?string,
  ugctype: UgcType,
  ugc_archetype: UgcType,
  created_date: ?string,
  updated_date: ?string,
  author: string,
  location: ?string,
  new_ugc_id: ?Id,
  old_ugc_id: ?Id,
  merchant_user_id: ?Id,
  review_headline: string,
  review_comments: ?string,
  service_comments?: ?string,
  ugc_edit_request_date: ?string,
  email?: ?string,
  reviewer_type: string,
  email_confirm_status?: ?string,
  source?: ?string,
  rating: ?number,
  ip_address?: ?string,
  device_id: ?string,
  tags: List<UgcTag>,
  clientSpecificQuestions: EmptyList | List<ClientSpecificQuestion>,
  ugc_related_content: EmptyList | List<Object>,
  locale?: ?string,
  published: ?boolean,
  bottom_line: ?boolean,
};

const defaultReviewRecord: ReviewRecordShape = {
  assigned_to: null,
  assigned_by: null,
  editable: false,
  ugc_id: null,
  subject_id: null,
  ugctype: 'Review',
  ugc_archetype: 'Review',
  created_date: null,
  updated_date: null,
  author: '',
  location: '',
  old_ugc_id: null,
  new_ugc_id: null,
  merchant_user_id: '',
  review_headline: '',
  review_comments: '',
  service_comments: '',
  ugc_edit_request_date: '',
  email: '',
  reviewer_type: '',
  email_confirm_status: '',
  source: '',
  helpful_votes: null,
  not_helpful_votes: null,
  rating: null,
  ip_address: '',
  device_id: '',
  review_content: '',
  tags: EmptyList,
  clientSpecificQuestions: EmptyList,
  catalog_response: [],
  review_responses: EmptyList,
  ugc_related_content: EmptyList,
  locale: '',
  published: null,
  bottom_line: null,
};

const ReviewRecord = Record(defaultReviewRecord);

const mapTagLabelToSortIndex = (label: string) => {
  const k = label.toLowerCase().replace(' ', '');

  switch (k) {
    case 'pros':
      return 0;
    case 'cons':
      return 1;
    case 'bestuses':
      return 2;
    case 'bottomline':
      return 3;
    default:
      return 4;
  }
};
const tagComparator = (lhs: UgcTag, rhs: UgcTag) => {
  const lLabel = mapTagLabelToSortIndex(lhs.label);
  const rLabel = mapTagLabelToSortIndex(rhs.label);

  return lLabel - rLabel;
};

export default class Review extends ReviewRecord implements Ugc {
  static createWithData(data: { [string]: any }) {
    const init = {};

    if (data.tags && Array.isArray(data.tags)) {
      init.tags = List(data.tags.sort().sort(tagComparator));
    }

    if (
      data.client_specific_question &&
      Array.isArray(data.client_specific_question)
    ) {
      init.clientSpecificQuestions = List(
        data.client_specific_question.map(ClientSpecificQuestion.create)
      );
    }

    return new Review({
      ...data,
      ...init,
    });
  }

  getResponseByType(type: UgcType) {
    return this.ugc_related_content.find(ugc => ugc.ugctype === type);
  }

  getMerchantResponse() {
    return this.getResponseByType('MerchantResponse');
  }

  getBrandResponse() {
    return this.getResponseByType('BrandMerchantResponse');
  }

  hasResponses(): boolean {
    return this.getMerchantResponse() || this.getBrandResponse();
  }

  getMedia(): List<Object> {
    return this.ugc_related_content.filter(
      ugc => ugc.ugctype === 'Image' || ugc.ugctype === 'Video'
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/Review.js